import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
// import { MenuHelper } from "src/app/menuHelper";

@Injectable({
  providedIn: 'root',
})
export class GlobalProvider {
  loadingJwt = true;
  profileType:any;
  profile:any;
  role:any;
  jws: any;
  accessRole:any={};
  mediaUrl:any;
  config:any;
  constructor(protected alertController: AlertController) {}


  async showConfirmPop(headMsg:any, subMsg:any, okText = 'Yes', cancelText = 'No') {
    return new Promise(async (res) => {
      const alert = await this.alertController.create({
        cssClass: 'my-custom-class',
        header: headMsg,
        message: subMsg,
        buttons: [
          {
            text: cancelText,
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              res(false);
              // console.log("Confirm Cancel: blah");
            },
          },
          {
            text: okText,
            handler: () => {
              res(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }

  async customConfirmPop(headMsg:any, subMsg:any, okText:any, cancelText:any) {
    return new Promise(async (res) => {
      const alert = await this.alertController.create({
        cssClass: 'customButtonConfirmation',
        header: headMsg,
        message: subMsg,
        buttons: [
          {
            text: cancelText,
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              res(false);
            },
          },
          {
            text: okText,
            handler: () => {
              res(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }

  async showAlert(header:any, message:any) {
    return new Promise(async (res) => {
      const alert = await this.alertController.create({
        cssClass: 'additionalReqAlert',
        header,
        message,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              res(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }

  
  checkRoleAccess(page:any, right:any) {
    if (this.role == 'ADMIN') return true;
    let arr = this.accessRole.accessRoleRights.find((el:any) => {
      return (
        el.accessClassName === page && (el.key === right || el.key === 'global')
      );
    });

    if (arr) {
      return true;
    } else {
      return false;
    }
  }

}
